import { createAction, props } from '@ngrx/store';
import { CopyVisualsDto, FileParameter, ImportVisualDuplicateHandling, ImportVisualResultDto, ListUserVisualDto, UserVisualDto } from '../../../services/api.services';
import { AppError } from '../../../shared/utils';
import { VisualsDisplayParams } from './reducer';

export const getVisuals = createAction(
  '[Visuals] Get Visuals'
);

export const getVisualsSuccess = createAction(
  '[Visuals] Get Visuals Success',
  props<{ visuals: ListUserVisualDto[] }>()
);

export const getVisualsFailure = createAction(
  '[Visuals] Get Visuals Failure',
  props<{ error: AppError }>()
);


export const expireCache = createAction(
  '[Visuals] Expire Visual Cache',
  props<{ visualIds: number[] }>()
);

export const expireCacheCompleted = createAction(
  '[Visuals] Expire Visual Cache Completed',
  props<{ visualIds: number[] }>()
);



export const setSelectedVisualIds = createAction(
  '[Visuals] Set Selected Visual Id',
  props<{ selectedVisualIds: number[] }>()
);


export const addVisual = createAction(
  '[Visuals] Add Visual'
);

export const editVisual = createAction(
  '[Visuals] Edit Visual',
  props<{ visualId: number }>()
);

export const viewVisual = createAction(
  '[Visuals] View Visual',
  props<{ visualId: number }>()
);

export const addScheduleVisual = createAction(
  '[Visuals] Add Schedule Visual',
  props<{ visualId: number }>()
);

export const copyVisuals = createAction(
  '[Visuals] Copy Visuals',
  props<CopyVisualsDto>()
);

export const copyVisualsSuccess = createAction(
  '[Visuals] Copy Visuals Success',
  props<{ visuals: ListUserVisualDto[] }>()
);

export const copyVisualsFailure = createAction(
  '[Visuals] Copy Visuals Failure',
  props<{ error: AppError }>()
);


export const showDeleteVisualDialog = createAction(
  '[Visuals] Show Delete Visual Dialog',
  props<{ visualIds: number[] }>()
);

export const deleteVisuals = createAction(
  '[Visuals] Delete Visuals',
  props<{ visualIds: number[] }> ()
);

export const deleteVisualsSuccess = createAction(
  '[Visuals] Delete Visuals Success',
  props<{ visualIds: number[] }>()
);

export const deleteVisualsFailure = createAction(
  '[Visuals] Delete Visuals Failure',
  props<{ error: AppError }>()
);


export const shareVisual = createAction(
  '[Visuals] Share Visual',
  props<{ visualId: number }>()
);

export const shareVisualSuccess = createAction(
  '[Visuals] Share Visual Success'
);

export const shareVisualFailure = createAction(
  '[Visuals] Share Visual Failure',
  props<{ error: AppError }>()
);


export const updateUserVisual = createAction(
  '[Visuals] Update User Visual',
  props<{ visual: ListUserVisualDto }>()
);

export const updateUserVisualSuccess = createAction(
  '[Visuals] Update User Visual Success',
  props<{ userVisual: UserVisualDto }>()
);

export const updateUserVisualFailure = createAction(
  '[Visuals] Update User Visual Failure',
  props<{ error: AppError }>()
);


export const toggleVisualLibrary = createAction(
  '[Visuals] Toggle Visual Library Inclusion',
  props<{ visualId: number }>()
);

export const toggleVisualLibrarySuccess = createAction(
  '[Visuals] Toggle Visual Library Inclusion Success',
  props<{ visualId: number, fromLibrary: boolean }>()
);

export const toggleVisualLibraryFailure = createAction(
  '[Visuals] Toggle Visual Library Inclusion Failure',
  props<{ error: AppError }>()
);


export const updateDisplayParams = createAction(
  '[Visuals] Update Display Params',
  props<{ displayParams: VisualsDisplayParams }>()
);


export const toggleVisualIsSample = createAction(
  '[Visuals] Toggle Visual IsSample',
  props<{ visualId: number }>()
);

export const toggleVisualIsSampleSuccess = createAction(
  '[Visuals] Toggle Visual IsSample Success',
  props<{ visualId: number, sample: boolean }>()
);

export const toggleVisualIsSampleFailure = createAction(
  '[Visuals] Toggle Visual IsSample Failure',
  props<{ error: AppError }>()
);


export const deleteSampleForUser = createAction(
  '[Visuals] Delete Sample For User',
  props<{ visualId: number }>()
);

export const deleteSampleForUserSuccess = createAction(
  '[Visuals] Delete Sample For User Success',
  props<{ visualId: number }>()
);

export const deleteSampleForUserFailure = createAction(
  '[Visuals] Delete Sample For User Failure',
  props<{ error: AppError }>()
);


export const openImportDialog = createAction(
  '[Visuals] Open Import Dialog'
);

export const importVisual = createAction(
  '[Visuals] Import Visual',
  props<{ file: FileParameter, duplicateHandling?: ImportVisualDuplicateHandling }>()
);

export const importVisualSuccess = createAction(
  '[Visuals] Import Visual Success',
  props<{ result: ImportVisualResultDto }>()
);

export const importVisualFailure = createAction(
  '[Visuals] Import Visual Failure',
  props<{ error: AppError }>()
);


export const exportDefinition = createAction(
  '[Visuals] Export Definition',
  props<{ visualIds: number[] }>()
);
